module.exports = __webpack_public_path__ + "img/refuse.7b6258e5.png";